import dayjs from 'types/dayjs.types';

export const MONTHLY_RUNS_PAY_GATE_MARKER = 'Monthly Runs';

export const isMonthlyRunsPayGateError = (errorText: string | null): boolean =>
  !!errorText && errorText.includes(MONTHLY_RUNS_PAY_GATE_MARKER);

export const getMonthlyRunsResetDate = (): string =>
  dayjs.utc().add(1, 'month').startOf('month').format('MMMM D, YYYY');
